module.exports = __webpack_public_path__ + "static/img/empty.30a26195.svg";